// PDFs from the API (reports, account reports). The API needs the
// Authorization header, so a plain link can't fetch them: they're loaded as
// a blob and opened or saved from an object URL.

// { url, filename } (filename from Content-Disposition, or null); throws the
// API's message
export async function fetchFile(path, token, errorMessage = "The file couldn't be loaded.") {
  const res = await fetch(path, { headers: { Authorization: "Bearer " + token } });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || errorMessage);
  }
  const match = /filename="([^"]+)"/.exec(res.headers.get("Content-Disposition") || "");
  return { url: URL.createObjectURL(await res.blob()), filename: match ? match[1] : null };
}

export function saveFile(url, filename) {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking right away can cancel the download in Safari and Firefox
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// view: in a new tab (the file is saved instead when pop-ups are blocked);
// otherwise saved as the API's file name, or `filename`
export async function openOrSave({ path, token, view, filename, errorMessage }) {
  // Open the tab now, while the click still counts as a user action;
  // opening it after the download would be blocked as a pop-up.
  const tab = view ? window.open("", "_blank") : null;
  try {
    const file = await fetchFile(path, token, errorMessage);
    if (tab) {
      tab.location.href = file.url;
      setTimeout(() => URL.revokeObjectURL(file.url), 60000);
    } else {
      saveFile(file.url, file.filename || filename);
    }
  } catch (err) {
    if (tab) tab.close();
    throw err;
  }
}
